import {
  LayoutDashboard,
  ShoppingCart,
  Package,
  ShoppingBag,
  BarChart3,
  Users,
  Gift,
  Shield,
  FileText,
  Building2,
  Menu,
  X,
  ChevronDown,
  Receipt,
  Store,
  ShieldAlert,
  Activity,
  Settings,
  Image,
  CreditCard,
  Truck,
  MessageSquare,
  GalleryHorizontal,
  PanelBottom,
  History,
  Tag,
  PanelLeftClose,
  PanelLeftOpen,
  ClipboardList,
} from 'lucide-react'
import { isAxiosError } from 'axios'
import { ReactNode, useState, useRef } from 'react'
import { Link, useLocation } from 'react-router'
import { cn } from '../lib/utils'
import { useSessionStore, type PermissionMatrix } from '../store/auth/auth.store'
import { authService } from '../services/auth.service'
import { LogOut, Loader2 } from 'lucide-react'
import { NotificationButton } from './ui/NotificationButton'
import { toast } from 'sonner'
import { useEffect } from 'react'
import { layoutService } from '../services/layout.service'
import { useDeviceStore } from '../store/auth/auth.store'
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from './ui/collapsible'
import { useSettingsBranding } from '../hooks/useSettingsBranding'
import { clearPrivateQueryCache } from '../lib/http/react-query'
import { POPUPS_FRONTEND_PREVIEW_ENABLED } from './popups/popup-access'

//CONSTANTE PARA OCULTAR MODULOS EN DESARROLLO Y MOSTRAR SOLO LOS DE PRODUCCION
const SHOW_ONLY_PRODUCTION_MODULES =
  import.meta.env.VITE_SHOW_ONLY_PRODUCTION_MODULES === 'true'

interface LayoutProps {
  children: ReactNode
}

const navigation = [
  {
    type: 'section',
    name: 'Punto de Venta',
    production: true,
  },
  {
    name: 'Panel General',
    href: '/',
    icon: LayoutDashboard,
    production: true,
    permission: 'dashboard.dashboard.view',
  },
  {
    name: 'Configuración',
    icon: Settings,
    production: true,
    children: [
      //{ name: 'Plataforma', href: '/configuracion/plataforma' }, NO LISTO PARA PRODUCCION
      { name: 'Métodos de Pago', href: '/metodos-pago', permission: 'configuration.payment-method.view' },
      { name: 'Cajas', href: '/cash-registers', permission: 'configuration.cash.view' },
      { name: 'Plataforma', href: '/configuracion/plataforma', permission: 'configuration.configuration.view' },
      { name: 'Temas', href: '/configuracion/temas', permission: 'configuration.configuration.view' },
      { name: 'Impuestos', href: '/impuestos', permission: 'configuration.tax.view' },
      { name: 'Unidad de Medida', href: '/unidades-medida', permission: 'configuration.unit.view' },
      { name: 'Bancos', href: '/bancos', permission: 'configuration.bank.view' },

    ],
  },
  {
    name: 'Punto de Venta',
    href: '/pos',
    icon: ShoppingCart,
    production: true,
    permission: 'pos.pos.view',
  },
  {
    name: 'Historial de caja',
    href: '/historial-caja',
    icon: History,
    production: true,
    permission: 'configuration.cash.view',
  },
  {
    name: 'Registro de Ventas',
    href: '/ventas',
    icon: Receipt,
    production: true,
    permission: 'sales.sale.view',
  },
  {
    name: 'Inventario',
    icon: Package,
    production: true,
    children: [
      { name: 'Catálogo', href: '/catalogo', permission: 'inventory.catalog.view' },
      { name: 'Trazabilidad', href: '/inventario/movimientos', permission: 'inventory.traceability.view' },
      { name: 'Categorías', href: '/categorias', permission: 'inventory.category.view' },
      { name: 'Departamentos', href: '/departamentos', permission: 'inventory.department.view' },
      { name: 'Tipos de Producto', href: '/tipos-producto', permission: 'inventory.product-type.view' },
      { name: 'Casos de uso', href: '/casos-de-uso', permission: 'inventory.use-case.view' },
      { name: 'Transferencias', href: '/inventario/transferencias', permission: 'inventory.catalog-transfer.view' },
    ],
  },
  {
    name: 'Promociones y Descuentos',
    href: '/promociones',
    icon: Tag,
    production: true,
    permission: 'promotions.promotion.view',
  },
  {
    name: 'Compras y Proveedores',
    href: '/compras',
    icon: ShoppingBag,
    permission: ['purchases.purchase.view', 'purchases.supplier.view', 'purchases.account_payable.view'],
    production: true,
  },
  {
    name: 'Reportes',
    href: '/reportes',
    icon: BarChart3,
    permission: ['reports.sales.view', 'reports.inventory.view', 'reports.cash-movements.view', 'reports.cash-registers.view', 'reports.sale-returns.view', 'reports.orders.view', 'reports.purchases.view', 'reports.cfdi.view'],
    production: true
  },
  { name: 'Clientes', href: '/clientes', icon: Users, production: true, permission: 'clients.customer.view' },
  { name: 'Programa de Lealtad', href: '/lealtad', icon: Gift, production: true, permission: 'loyalty.loyalty.view' },
  {
    name: 'Logs del Sistema',
    icon: Activity,
    production: true,
    children: [
      { name: 'Logs de Accesos', href: '/logs-accesos', permission: 'logs.access-log.view' },
      { name: 'Logs de Acciones', href: '/logs-acciones', permission: 'logs.activity-log.view' },
    ],
  },
  /*
  {
    name: 'Notificaciones',
    href: '/notificaciones',
    icon: Bell,
    production: true,
  },
  */
  {
    name: 'Usuarios y Permisos',
    href: '/usuarios',
    icon: Shield,
    production: true,
    permission: 'users.user.view',
  },
  {
    name: 'Sucursales',
    href: '/sucursales',
    icon: Building2,
    production: true,
    permission: 'sucursals.sucursal.view',
  },
  {
    name: 'Módulo Regulatorio',
    href: '/regulatorio',
    icon: FileText,
    production: true,
    children: [
      { name: 'Doctores', href: '/doctores', permission: 'doctors.doctor.view' },
      //{ name: 'Control Regulatorio', href: '/regulatorio' }, NO LISTO PARA PRODUCCION
    ],
  },
  {
    name: 'Dashboard Sucursales',
    href: '/dashboard-sucursales',
    icon: Store,
    production: true,
    permission: 'dashboard.dashboard.view',
  },
  // ------------ TIENDA EN LINEA ------------------
  {
    type: 'section',
    name: 'Tienda en línea',
    production: true,
  },
  {
    name: 'Pedidos en línea',
    href: '/tienda/pedidos',
    icon: ClipboardList,
    production: true,
    permission: 'ecommerce.order.view',
  },
  {
    name: 'Configuración de tienda',
    href: '/tienda/configuracion',
    icon: Settings,
    production: true,
    //permission: 'online-store.configuration.view',
  },

  {
    name: 'Diseño y página principal',
    href: '/tienda/diseno',
    icon: LayoutDashboard,
    production: true,
    permission: 'ecommerce.home_component.view',
  },

  {
    name: 'Banners',
    href: '/tienda/banners',
    icon: Image,
    production: true,
    permission: 'ecommerce.banner.view',
  },

  {
    name: 'Promociones (4 Cards)',
    href: '/tienda/secciones-promociones',
    icon: Image,
    production: true,
  },

  {
    name: 'Carruseles de productos',
    href: '/tienda/carruseles',
    icon: GalleryHorizontal,
    production: true,
    permission: 'ecommerce.carousel.view',
  },

  {
    name: 'Menús',
    href: '/tienda/navbar',
    icon: Menu,
    production: true,
    permission: 'ecommerce.navigation-menu.view',
  },
  /*
  {
    name: 'Footer',
    href: '/tienda/footer',
    icon: PanelBottom,
    production: false,
    //permission: 'online-store.footer.view',
  },
  */

  {
    name: 'Popups y emergentes',
    href: '/tienda/popups',
    icon: MessageSquare,
    production: true,
    permission: POPUPS_FRONTEND_PREVIEW_ENABLED
      ? undefined
      : 'online-store.popup.view',
  },

  {
    name: 'Productos publicados',
    href: '/tienda/productos',
    icon: ShoppingBag,
    production: true,
    permission: 'ecommerce.catalog.view',
  },

  {
    name: 'Métodos de pago',
    href: '/tienda/metodos-pago',
    icon: CreditCard,
    production: true,
    //permission: 'online-store.payment-method.view',
  },
]

function hasMatrixPermission(
  permissions: PermissionMatrix,
  permission: string | string[],
) {
  const hasAction = (action: string) => {
    const [module, resource, verb] = action.split('.')

    return Boolean(
      module
      && resource
      && verb
      && permissions[module]?.[resource]?.[verb],
    )
  }

  return Array.isArray(permission)
    ? permission.some(hasAction)
    : hasAction(permission)
}

// eslint-disable-next-line react-refresh/only-export-components
export function getFirstAccessibleRoute(
  permissions: PermissionMatrix,
  showOnlyProductionModules = SHOW_ONLY_PRODUCTION_MODULES,
): string | null {
  const visibleNavigation = showOnlyProductionModules
    ? navigation.filter((item) => item.production)
    : navigation

  for (const item of visibleNavigation) {
    if ('children' in item && item.children) {
      for (const child of item.children) {
        if (!('permission' in child) || !child.permission) continue

        if (hasMatrixPermission(permissions, child.permission)) {
          return child.href
        }
      }

      continue
    }

    if (
      !('href' in item)
      || !item.href
      || !('permission' in item)
      || !item.permission
    ) {
      continue
    }

    if (hasMatrixPermission(permissions, item.permission)) {
      return item.href
    }
  }

  return null
}

export function Layout({ children }: LayoutProps) {
  const location = useLocation()
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [isCollapsed, setIsCollapsed] = useState(() => {
    const saved = localStorage.getItem('sidebar_collapsed')
    return saved ? JSON.parse(saved) : false
  })

  useEffect(() => {
    localStorage.setItem('sidebar_collapsed', JSON.stringify(isCollapsed))
  }, [isCollapsed])

  useEffect(() => {
    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        window.location.reload()
      }
    }

    window.addEventListener('pageshow', handlePageShow)

    return () => window.removeEventListener('pageshow', handlePageShow)
  }, [])

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        branchDropdownRef.current &&
        !branchDropdownRef.current.contains(event.target as Node)
      ) {
        setBranchDropdownOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])
  const [branches, setBranches] = useState<{ id: number, name: string }[]>([])
  const [selectedBranch, setSelectedBranch] = useState<{ id: number, name: string } | null>(null)
  const [openMenus, setOpenMenus] = useState<string[]>([])

  const [branchDropdownOpen, setBranchDropdownOpen] = useState(false)
  const branchDropdownRef = useRef<HTMLDivElement>(null)
  const [isLoggingOut, setIsLoggingOut] = useState(false)
  const [isChangingBranch, setIsChangingBranch] = useState(false)
  const [isRefreshingPermissions, setIsRefreshingPermissions] = useState(false)
  const { token, user, logout, activeBranchId, setActiveBranchId, isRevoked, revokeMessage, clearRevoked, setRevoked, canAction, permissions, setPermissions } = useSessionStore()
  const { branding } = useSettingsBranding({ mode: 'private', enabled: Boolean(token) })

  const [isOnline, setIsOnline] = useState<boolean | undefined>(undefined)
  const firstAccessibleRoute = getFirstAccessibleRoute(permissions)
  const permissionsLoaded = user?.permissions !== undefined
  const hasNoViewAccess = !isRevoked && permissionsLoaded && firstAccessibleRoute === null

  const hasPermission = (permission?: string | string[]) => {
    if (!permission) return true
    return Array.isArray(permission)
      ? permission.some((action) => canAction(action))
      : canAction(permission)
  }

  const filteredNavigation = (SHOW_ONLY_PRODUCTION_MODULES
    ? navigation.filter(item => item.production)
    : navigation)
    .map((item) => {
      if (!('children' in item) || !item.children) return item

      return {
        ...item,
        children: item.children.filter((child) => {
          const permission = 'permission' in child && typeof child.permission === 'string'
            ? child.permission
            : undefined

          return !permission || canAction(permission)
        }),
      }
    })
    .filter((item) => {
      if ('children' in item && item.children) return item.children.length > 0

      return !('permission' in item) || hasPermission(item.permission)
    })


  const [branchToChange, setBranchToChange] = useState<{
    id: number
    name: string
  } | null>(null)

  useEffect(() => {
    let isMounted = true
    /*
      Servicio del layout para obtener las sucursales asignadas al usuario
      se agregan para gestionar la sucursal activa en la sesion del usuario
      en caso de que la sucursal activa no sea valida se muestra un mensaje de error
      y se permite seleccionar otra sucursal
      
    */
    Promise.all([
      layoutService.getMySucursales(),
      authService.getSucursalContext(),
    ]).then(([data, context]) => {
      if (!isMounted) return
      setBranches(data)

      if (data.length === 0) {
        setRevoked('No tienes sucursales activas asignadas en este momento.')
        return
      }

      const authoritativeBranch = data.find(branch => branch.id === context.sucursal.id)
      if (!authoritativeBranch) {
        setRevoked('No tienes acceso a la sucursal autenticada en este momento.')
        return
      }

      setActiveBranchId(authoritativeBranch.id)
      setSelectedBranch(authoritativeBranch)

      const storedDevice = useDeviceStore.getState().trustedDevice
      if (storedDevice) {
        useDeviceStore.getState().setTrustedDevice({
          ...storedDevice,
          sucursal_id: authoritativeBranch.id,
          sucursal_name: authoritativeBranch.name,
        })
      }
    }).catch(e => {
      console.error(e)
      toast.error('Error al cargar sucursales asignadas')
    })

    return () => { isMounted = false }
  }, [setActiveBranchId, setRevoked])

  useEffect(() => {
    const activeParents = filteredNavigation
      .filter(item => item.children?.some(child => location.pathname === child.href))
      .map(item => item.name)

    setOpenMenus(prev => Array.from(new Set([...prev, ...activeParents])))
  }, [location.pathname])

  /*
    Alterna la expansion de los menus del sidebar
  */
  const toggleMenu = (name: string) => {
    setOpenMenus(prev =>
      prev.includes(name)
        ? prev.filter(n => n !== name)
        : [...prev, name]
    )
  }

  /*
    Maneja el estado de conexion del navegador
    y muestra una notificacion cuando el navegador se queda sin conexion
  */
  useEffect(() => {
    const checkInitialState = async () => {
      try {
        const res = await layoutService.getBrowserConnectionState()
        setIsOnline(res)

        if (!res) {
          toast.error('Sin conexión a internet')
        }
      } catch (e) {
        console.error(e)
      }
    }
    checkInitialState()

    const handleOnline = () => {
      setIsOnline(true)
      toast.success('Conectado a internet')
    }

    const handleOffline = () => {
      setIsOnline(false)
      toast.error('Sin conexión a internet')
    }

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  /*
    Maneja el cierre de sesion del usuario
    llama al servicio de authService.logout() para cerrar sesion
    y limpia la sesion del usuario
    muestra un mensaje de exito
    y redirige al usuario a la pagina de inicio
  */
  const handleLogout = async () => {
    setIsLoggingOut(true)
    try {
      await authService.logout()
    } catch (e) {
      console.error(e)
    } finally {
      clearPrivateQueryCache()
      logout()
      setIsLoggingOut(false)
      toast.success('Sesión cerrada correctamente')
    }
  }

  /*
    Maneja el cambio de sucursal
    llama a la funcion setActiveBranchId para establecer la nueva sucursal activa
    y recarga la pagina
  */
  const confirmBranchChange = async () => {
    if (!branchToChange) return

    const expectedSucursalId = useSessionStore.getState().activeBranchId
    if (!expectedSucursalId) {
      toast.error('No fue posible identificar la sucursal actual.')
      return
    }

    setIsChangingBranch(true)
    try {
      const context = await authService.switchSucursalContext({
        sucursal_id: branchToChange.id,
        expected_sucursal_id: expectedSucursalId,
      })
      setActiveBranchId(context.sucursal.id)
      setSelectedBranch(context.sucursal)

      const storedDevice = useDeviceStore.getState().trustedDevice
      if (storedDevice) {
        useDeviceStore.getState().setTrustedDevice({
          ...storedDevice,
          sucursal_id: context.sucursal.id,
          sucursal_name: context.sucursal.name,
        })
      }

      clearPrivateQueryCache()
      window.location.reload()
    } catch (error: unknown) {
      const message = isAxiosError<{ message?: string }>(error)
        ? error.response?.data?.message
        : undefined
      toast.error(message || 'No fue posible cambiar de sucursal.')
    } finally {
      setIsChangingBranch(false)
    }
  }

  const refreshPermissions = async () => {
    setIsRefreshingPermissions(true)

    try {
      const updatedPermissions = await authService.permissions()
      setPermissions(updatedPermissions)

      const destination = getFirstAccessibleRoute(updatedPermissions)
      if (destination) {
        window.location.replace(destination)
        return
      }

      toast.warning('Aún no tienes permisos para acceder a una vista.')
    } catch (error) {
      console.error(error)
      toast.error('No fue posible actualizar tus permisos. Intenta de nuevo.')
    } finally {
      setIsRefreshingPermissions(false)
    }
  }

  if (!permissionsLoaded && !isRevoked) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-50">
        <div className="flex items-center gap-3 text-slate-600">
          <Loader2 className="h-5 w-5 animate-spin" />
          <span className="font-medium">Validando acceso...</span>
        </div>
      </div>
    )
  }

  if (isRevoked || hasNoViewAccess) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm">
        <div className="w-full max-w-md rounded-2xl bg-white p-8 shadow-2xl text-center">
          <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
            <ShieldAlert className="h-8 w-8 text-red-600" />
          </div>
          <h2 className="text-2xl font-bold text-slate-900 mb-2">
            {hasNoViewAccess ? 'Acceso denegado' : 'Acceso Suspendido'}
          </h2>
          <p className="text-slate-500 mb-8">
            {hasNoViewAccess
              ? 'No tienes permiso para acceder a ninguna vista. Solicita a un administrador que te asigne al menos un permiso de consulta.'
              : revokeMessage || 'Se ha revocado tu acceso a la sucursal actual.'}
          </p>

          {hasNoViewAccess ? (
            <div className="space-y-3">
              <button
                onClick={() => void refreshPermissions()}
                disabled={isRefreshingPermissions || isLoggingOut}
                className="flex w-full items-center justify-center gap-2 rounded-xl bg-slate-900 px-4 py-3 font-semibold text-white transition-colors hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-70"
              >
                {isRefreshingPermissions && <Loader2 className="h-4 w-4 animate-spin" />}
                Actualizar sesión
              </button>
              <button
                onClick={() => void handleLogout()}
                disabled={isRefreshingPermissions || isLoggingOut}
                className="flex w-full items-center justify-center gap-2 rounded-xl border border-slate-300 bg-white px-4 py-3 font-semibold text-slate-700 transition-colors hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-70"
              >
                {isLoggingOut ? <Loader2 className="h-4 w-4 animate-spin" /> : <LogOut className="h-4 w-4" />}
                Cerrar sesión
              </button>
            </div>
          ) : (
            <button
              onClick={() => {
                if (branches.length === 0) {
                  clearPrivateQueryCache()
                  logout()
                  window.location.href = '/'
                } else {
                  clearRevoked()
                  window.location.reload()
                }
              }}
              className="w-full rounded-xl bg-slate-900 px-4 py-3 font-semibold text-white transition-colors hover:bg-slate-800"
            >
              {branches.length === 0 ? 'Cerrar sesión' : 'Actualizar sesión'}
            </button>
          )}
        </div>
      </div>
    )
  }

  return (
    <div className="flex h-screen w-full max-w-[100vw] bg-background overflow-hidden overscroll-none">
      {/* Sidebar */}
      {/* Sidebar */}
      <aside
        className={cn(
          'fixed inset-y-0 left-0 z-50 transform transition-all duration-300 ease-in-out lg:static lg:inset-0',
          sidebarOpen ? 'translate-x-0' : '-translate-x-full',
          isCollapsed ? 'lg:w-[84px]' : 'lg:w-64',
          'w-64 lg:translate-x-0',
          'bg-sidebar text-sidebar-foreground border-r border-sidebar-border'
        )}
      >
        <div className="flex h-full flex-col">
          {/* Header */}
          <div className="p-4 border-b border-sidebar-border">
            <div className={cn("flex items-center", isCollapsed ? "justify-center" : "justify-between")}>
              {!isCollapsed && <img src={branding.logoMainUrl} alt={branding.companyName} className="h-14 w-auto max-w-[190px] object-contain" />}

              <button
                onClick={() => setIsCollapsed(!isCollapsed)}
                className="hidden lg:block rounded-md p-1.5 transition-colors text-sidebar-foreground hover:bg-sidebar-accent hover:text-sidebar-accent-foreground"
                title={isCollapsed ? "Expandir menú" : "Contraer menú"}
              >
                {isCollapsed ? <PanelLeftOpen className="h-5 w-5" /> : <PanelLeftClose className="h-5 w-5" />}
              </button>

              <button
                onClick={() => setSidebarOpen(false)}
                className="rounded-md p-1 hover:bg-sidebar-accent hover:text-sidebar-accent-foreground text-sidebar-foreground lg:hidden"
              >
                <X className="h-5 w-5" />
              </button>
            </div>
          </div>

          {/* Branch Selector */}
          <div ref={branchDropdownRef} className="relative mt-3 px-3 pb-3 border-b border-sidebar-border">
            <button
              onClick={() => branches.length > 1 && setBranchDropdownOpen(!branchDropdownOpen)}
              disabled={branches.length <= 1}
              title={isCollapsed ? (selectedBranch?.name || 'Cargando...') : undefined}
              className={cn(
                'flex w-full items-center rounded-lg py-2 transition-colors border border-sidebar-border bg-sidebar-branch text-sidebar-foreground hover:bg-sidebar-branch-hover hover:text-sidebar-accent-foreground',
                isCollapsed ? 'justify-center px-0' : 'justify-between px-3',
                branches.length > 1 ? 'cursor-pointer' : 'opacity-80 cursor-default'
              )}
            >
              <div className={cn("flex items-center", !isCollapsed && "gap-2")}>
                <Building2 className="h-4 w-4 shrink-0 text-sidebar-foreground" />
                {!isCollapsed && (
                  <span className="text-sm truncate text-sidebar-foreground">
                    {selectedBranch?.name || 'Cargando...'}
                  </span>
                )}
              </div>
              {!isCollapsed && branches.length > 1 && <ChevronDown className="h-4 w-4 shrink-0 text-sidebar-foreground" />}
            </button>

            {branchDropdownOpen && (
              <div className="absolute top-full right-0 left-0 z-10 mt-1 rounded-lg border border-sidebar-border bg-sidebar text-sidebar-foreground shadow-lg">
                {branches.map((branch) => (
                  <button
                    key={branch.id}
                    onClick={() => {
                      if (branch.id !== activeBranchId) {
                        setBranchDropdownOpen(false)
                        setBranchToChange(branch)
                      } else {
                        setBranchDropdownOpen(false)
                      }
                    }}
                    className={cn(
                      'w-full px-3 py-2 text-left text-sm first:rounded-t-lg last:rounded-b-lg hover:bg-sidebar-accent hover:text-sidebar-accent-foreground transition-colors',
                      selectedBranch?.id === branch.id &&
                      'bg-sidebar-primary text-sidebar-primary-foreground font-medium',
                    )}
                  >
                    {branch.name}
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* Navigation */}
          <nav className="flex-1 space-y-1 overflow-y-auto p-3">
            {filteredNavigation.map((item) => {
              if ('type' in item && item.type === 'section') {
                return (
                  <div key={item.name} className="my-4">
                    {!isCollapsed ? (
                      <>
                        <hr className="border-sidebar-border" />
                        <div className="mt-3 px-3 text-[10px] font-semibold uppercase tracking-wider text-sidebar-foreground/50">
                          {item.name}
                        </div>
                      </>
                    ) : (
                      <hr className="border-sidebar-border" />
                    )}
                  </div>
                )
              }
              if (item.children) {
                const isActive = item.children.some(child => location.pathname === child.href)
                const isOpen = openMenus.includes(item.name)

                return (
                  <Collapsible
                    key={item.name}
                    open={isCollapsed ? false : isOpen}
                    onOpenChange={() => {
                      if (isCollapsed) {
                        setIsCollapsed(false)
                        if (!isOpen) toggleMenu(item.name)
                      } else {
                        toggleMenu(item.name)
                      }
                    }}
                    className="space-y-1"
                  >
                    <CollapsibleTrigger
                      title={isCollapsed ? item.name : undefined}
                      className={cn(
                        'flex w-full items-center rounded-lg py-2 transition-colors',
                        isCollapsed ? 'justify-center px-0' : 'justify-between px-3',
                        isActive
                          ? 'bg-sidebar-primary text-sidebar-primary-foreground font-medium'
                          : 'text-sidebar-foreground hover:bg-sidebar-accent hover:text-sidebar-accent-foreground'
                      )}
                    >
                      <div className={cn("flex items-center", !isCollapsed && "gap-3")}>
                        <item.icon className="h-5 w-5 shrink-0" />
                        {!isCollapsed && <span className="text-sm font-medium">{item.name}</span>}
                      </div>
                      {!isCollapsed && <ChevronDown className={cn("h-4 w-4 transition-transform shrink-0", isOpen && "rotate-180")} />}
                    </CollapsibleTrigger>
                    <CollapsibleContent className="pt-1">
                      <div className="relative ml-3 border-l-2 border-sidebar-border pl-3 space-y-0.5">
                        {item.children.map((child, idx) => {
                          const isChildActive = location.pathname === child.href
                          return (
                            <Link
                              key={child.name}
                              to={child.href}
                              onClick={() => setSidebarOpen(false)}
                              style={{
                                animationDelay: `${idx * 40}ms`,
                                animationFillMode: 'both',
                              }}
                              className={cn(
                                'flex items-center gap-2 rounded-lg px-3 py-2 text-sm transition-all duration-150',
                                'animate-in fade-in slide-in-from-left-2',
                                isChildActive
                                  ? 'bg-sidebar-primary text-sidebar-primary-foreground font-medium'
                                  : 'text-sidebar-foreground hover:bg-sidebar-accent hover:text-sidebar-accent-foreground'
                              )}
                            >
                              <span
                                className={cn(
                                  'h-1.5 w-1.5 rounded-full shrink-0 transition-colors',
                                  isChildActive ? 'bg-sidebar-primary-foreground' : 'bg-sidebar-foreground/40',
                                )}
                              />
                              {child.name}
                            </Link>
                          )
                        })}
                      </div>
                    </CollapsibleContent>
                  </Collapsible>
                )
              }

              const isActive = location.pathname === item.href
              return (
                <Link
                  key={item.name}
                  to={item.href!}
                  title={isCollapsed ? item.name : undefined}
                  onClick={() => setSidebarOpen(false)}
                  className={cn(
                    'flex items-center rounded-lg py-2 transition-colors',
                    isCollapsed ? 'justify-center px-0' : 'justify-between px-3 gap-3',
                    isActive
                      ? 'bg-sidebar-primary text-sidebar-primary-foreground font-medium'
                      : 'text-sidebar-foreground hover:bg-sidebar-accent hover:text-sidebar-accent-foreground'
                  )}
                >
                  <span className={cn("flex items-center", !isCollapsed && "gap-3 w-full min-w-0")}>
                    {item.icon && <item.icon className="h-5 w-5 shrink-0" />}
                    {!isCollapsed && <span className="truncate text-sm font-medium">{item.name}</span>}
                  </span>
                </Link>
              )
            })}
          </nav>

          {/* Footer */}
          <div className="p-4 border-t border-sidebar-border">
            <div className={cn("flex flex-col", isCollapsed ? "gap-4 items-center" : "gap-3")}>
              <div className={cn("flex items-center", !isCollapsed && "gap-3")}>
                <div className="flex h-10 w-10 shrink-0 overflow-hidden items-center justify-center rounded-full bg-sidebar-primary text-sidebar-primary-foreground">
                  {user?.avatar_url ? (
                    <img src={user.avatar_url} alt={user.name} className="h-full w-full object-cover" />
                  ) : (
                    <span className="text-sm font-medium">
                      {user?.name?.substring(0, 2).toUpperCase() || 'U'}
                    </span>
                  )}
                </div>
                {!isCollapsed && (
                  <div className="flex-1 overflow-hidden">
                    <div className="truncate text-sm font-medium text-sidebar-foreground">
                      {user?.name || 'Usuario'}
                    </div>
                    <div className="truncate text-xs text-sidebar-foreground/70">
                      {user?.role?.name || 'Vendedor'}
                    </div>
                  </div>
                )}
              </div>

              <div className={cn("flex items-center", isCollapsed ? "flex-col gap-3 w-full" : "gap-2 mt-1")}>
                {/* Pill de Estado */}
                {!isCollapsed ? (
                  <div className="flex-1 flex items-center justify-center gap-2 px-3 py-1.5 bg-sidebar-accent/50 border border-sidebar-border shadow-sm rounded-full text-sidebar-foreground">
                    <span className="relative flex h-2 w-2 shrink-0">
                      {isOnline && (
                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                      )}
                      <span className={cn("relative inline-flex rounded-full h-2 w-2 shrink-0", isOnline ? "bg-green-500" : "bg-red-500")}></span>
                    </span>
                    <span className="text-[10px] font-bold uppercase tracking-widest text-sidebar-foreground/80">{isOnline ? 'En línea' : 'Sin conexión'}</span>
                  </div>
                ) : (
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-sidebar-accent/50 border border-sidebar-border shadow-sm text-sidebar-foreground" title={isOnline ? 'En línea' : 'Sin conexión'}>
                    <span className="relative flex h-2 w-2 shrink-0">
                      {isOnline && (
                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                      )}
                      <span className={cn("relative inline-flex rounded-full h-2 w-2 shrink-0", isOnline ? "bg-green-500" : "bg-red-500")}></span>
                    </span>
                  </div>
                )}

                {/* Botones de Acción */}
                <div className={cn("flex items-center justify-center shrink-0", isCollapsed ? "flex-col gap-3" : "gap-2")}>
                  <div className="hidden lg:block shrink-0">
                    <NotificationButton mode="drawer" className="h-9 w-9 bg-sidebar-accent/50 border border-sidebar-border shadow-sm hover:bg-sidebar-accent hover:text-sidebar-accent-foreground text-sidebar-foreground transition-all" />
                  </div>
                  <button
                    onClick={handleLogout}
                    disabled={isLoggingOut}
                    className="flex items-center justify-center rounded-full h-9 w-9 bg-sidebar-accent/50 border border-sidebar-border shadow-sm hover:bg-sidebar-accent hover:text-sidebar-accent-foreground text-sidebar-foreground transition-all disabled:opacity-50 shrink-0"
                    title="Cerrar sesión"
                  >
                    {isLoggingOut ? <Loader2 className="h-4 w-4 animate-spin text-sidebar-foreground/50" /> : <LogOut className="h-4 w-4 shrink-0" />}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 min-w-0 w-full h-full overflow-y-auto overflow-x-hidden overscroll-none">
        {/* Mobile header */}
        <div className="sticky top-0 z-40 border-b border-slate-200 bg-white px-4 py-3 lg:hidden">
          <div className="flex items-center justify-between">
            <button
              onClick={() => setSidebarOpen(true)}
              className="rounded-md p-1 hover:bg-slate-100"
            >
              <Menu className="h-6 w-6" />
            </button>
            <img src={branding.logoMainUrl} alt={branding.companyName} className="h-7" />
            <NotificationButton mode="popover" className="h-8 w-8 text-slate-400 hover:bg-slate-100 border-none bg-transparent shadow-none" />
          </div>
        </div>

        {children}
      </main>

      {branchToChange && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-xl">
            <h3 className="text-lg font-semibold text-slate-900">
              Cambiar sucursal
            </h3>

            <p className="mt-2 text-sm text-slate-600">
              ¿Deseas cambiar a {' '}
              <span className="font-medium">
                {branchToChange.name}
              </span>
              ?
            </p>

            <p className="mt-2 text-xs text-slate-500">
              La aplicación se recargará para actualizar la información de la
              sucursal seleccionada.
            </p>

            <div className="mt-6 flex justify-end gap-3">
              <button
                onClick={() => setBranchToChange(null)}
                className="rounded-lg border border-slate-300 px-4 py-2 text-sm hover:bg-slate-50"
              >
                Cancelar
              </button>

              <button
                onClick={confirmBranchChange}
                disabled={isChangingBranch}
                className="rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90 disabled:opacity-50"
              >
                {isChangingBranch ? 'Cambiando...' : 'Confirmar'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/50 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </div>
  )
}
